import { loadStateFilter } from '../../AsyncLoader';

/**
 * @param {import('./StateFilter').StateFilterConfig} config 
 */
async function register(config) {
  const StateFilter = await loadStateFilter();

  return new StateFilter(config);
}

export {
  register,
};


// WEBPACK FOOTER //
// ./src/tnew/lib/StateFilterRegistration.js